import { apiClient } from './apiClient';

export const API_APP_BAI_TAP_PATH = "bai-tap-type"

export const baiTapTypeApi = {
    SelectAll: () => apiClient.get(API_APP_BAI_TAP_PATH)
}